import React, { Component } from "react";
import TrimbleMaps from "@trimblemaps/trimblemaps-js";
import RecenterControl from "./controls/RecenterControl";
import constant from "../utils/mapconstants";
import SatelliteViewControl from "./controls/SatelliteViewControl";
import ShowZonesControl from "./controls/ShowZonesControl";
import {withMapContext} from "./MapContext"

class MapControls extends Component {
  constructor(props) {
    super(props);
    this.satelliteViewControl = null;
    this.showZonesControl = null;
  }
  shouldComponentUpdate(nextprops) {
    if (this.recenterControl && this.props.mapCenter !== nextprops.mapCenter) {
      this.recenterControl.setMapCenter(nextprops.mapCenter);
    }

    if (this.props.theme !== nextprops.theme) {
      if (this.satelliteViewControl) {
        this.satelliteControl = this.satelliteViewControl._controls.find(
          (ele) => ele.title === "SatelliteViewControl"
        );
        this.satelliteControl.theme = nextprops.theme;
      }
      return true;
    }
    if (
      this.props.controlOptions.showZones &&
      this.props.controlOptions.showZones.terminalID !==
        nextprops.controlOptions.showZones.terminalID
    ) {
      if (this.showZonesControl) {
        this.showZonesView = this.showZonesControl._controls.find(
          (ele) => ele.id === "showZonesCustomControl"
        );
        this.showZonesView.updateProps({
          terminalId: nextprops.controlOptions.showZones.terminalID,
          geoJson: nextprops.controlOptions.showZones?.geoJson,
        });
      }
      return true;
    }
    if (this.props) return false;
  }

  componentDidMount() {
    if (this.props.map) {
      const {
        fullscreenControl,
        zoomControl,
        satelliteViewControl,
        reCenterMapControl,
        showZones,
      } = this.props.controlOptions;
      const { map, mapCenter } = this.props;

      map.addControl(
        new TrimbleMaps.NavigationControl({
          showCompass: true,
          showZoom: Boolean(zoomControl),
          visualizePitch: true,
        }),
        constant.CONTROL_POSITION.BOTTOM_RIGHT
      );

      if (fullscreenControl) {
        map.addControl(
          new TrimbleMaps.FullscreenControl(),
          constant.CONTROL_POSITION.BOTTOM_RIGHT
        );
      }

      if (reCenterMapControl) {
        this.recenterControl = new RecenterControl({ center: mapCenter });
        map.addControl(
          this.recenterControl,
          constant.CONTROL_POSITION.BOTTOM_RIGHT
        );
      }

      if (satelliteViewControl) {
        this.satelliteViewControl = map.addControl(
          new SatelliteViewControl({
            theme: this.props.theme,
            title: "SatelliteViewControl",
            isDefaultSattelite: this.props.isDefaultSattelite,
          }),
          constant.CONTROL_POSITION.BOTTOM_RIGHT
        );
      }

      if (showZones) {
        this.showZonesControl = map.addControl(
          new ShowZonesControl({
            terminalId: showZones.terminalID,
            onZoneClicked: showZones.onZoneClicked,
            geoJson: showZones?.geoJson,
          }),
          constant.CONTROL_POSITION.BOTTOM_RIGHT
        );
      }
    }
  }
  render() {
    return null;
  }
}

export default withMapContext(MapControls);
